import { Injectable } from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Patient} from '../components/order-entry/patient';
import {FormGroup} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  constructor(private http: HttpClient) {}
  urlEndPoint = environment.endPoint;

  getPatient(patient: FormGroup): Observable<Patient> {
    const params = new URLSearchParams();
    params.set('fiscalCode', patient.get('fiscalCode').value);
    params.set('name', patient.get('name').value);
    params.set('surname', patient.get('surname').value);
    return this.http.get<Patient>(this.urlEndPoint + '/api/search-patients?' + params.toString());
  }
}
